import { sygnet } from './sygnet';
import { logo } from './logo';
import { logoNegative } from './logo-negative';

import {
  cibSkype,
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibStackoverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
  cibCcAmex,
  cibOpsgenie,
  cibGmail,
} from '@coreui/icons';
import {
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl,
} from '@coreui/icons';
import {
  cilAlignCenter,
  cilAlignLeft,
  cilAlignRight,
  cilApplicationsSettings,
  cilArrowCircleTop,
  cilArrowRight,
  cilArrowBottom,
  cilArrowTop,
  cilAsterisk,
  cilBan,
  cilBasket,
  cilBell,
  cilBold,
  cilBookmark,
  cilCalculator,
  cilCalendar,
  cilCloudDownload,
  cilChartPie,
  cilCheck,
  cilChevronBottom,
  cilChevronLeft,
  cilChevronRight,
  cilChevronTop,
  cilCircle,
  cilCheckCircle,
  cilCode,
  cilCommentSquare,
  cilCreditCard,
  cilCursor,
  cilCursorMove,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeLetter,
  cilEnvelopeOpen,
  cilEuro,
  cilGlobeAlt,
  cilGrid,
  cilHeart,
  cilFile,
  cilFullscreen,
  cilFullscreenExit,
  cilGraph,
  cilHome,
  cilInbox,
  cilIndentDecrease,
  cilIndentIncrease,
  cilInputPower,
  cilItalic,
  cilJustifyCenter,
  cilJustifyLeft,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilListNumbered,
  cilListRich,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMap,
  cilMoon,
  cilNotes,
  cilOptions,
  cilPaperclip,
  cilPaperPlane,
  cilPencil,
  cilPeople,
  cilPhone,
  cilPrint,
  cilPuzzle,
  cilSave,
  cilScrubber,
  cilSettings,
  cilShare,
  cilShareAll,
  cilShareBoxed,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilSun,
  cilTags,
  cilTask,
  cilTrash,
  cilUnderline,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilUserUnfollow,
  cilX,
  cilXCircle,
  cilWarning,
  cilMoney,
  cilPlus,
  cilClone,
  cilAccountLogout,
  cilMinus,
  cilDataTransferDown,
  cilDataTransferUp,
  cilLoop,
  cilPlaylistAdd,
  cilFlagAlt,
  cilInfo,
  cilExternalLink,
  cilCheckAlt,
  cilActionUndo,
  cilCommentBubble,
  cilDelete,
  cilClock,
  cilCaretBottom,
} from '@coreui/icons';

const DashIcon = ['129.6 129.6', `
  <path fill="currentColor" d="M42.64,3.98H22.198c-8.346,0-15.174,6.829-15.174,15.174v33.98c0,8.346,6.828,15.174,15.174,15.174H42.64
    c8.346,0,15.174-6.829,15.174-15.174v-33.98C57.814,10.808,50.986,3.98,42.64,3.98z"/>
  <path fill="currentColor" d="M42.968,81.085H21.865c-8.346,0-15.174,6.828-15.174,15.174v13.874c0,8.346,6.828,15.174,15.174,15.174
    h21.103c8.346,0,15.174-6.828,15.174-15.174V96.259C58.141,87.913,51.313,81.085,42.968,81.085z"/>
  <path fill="currentColor" d="M106.643,125.307H86.201c-8.346,0-15.174-6.829-15.174-15.174V76.154c0-8.346,6.828-15.175,15.174-15.175
    h20.441c8.346,0,15.174,6.829,15.174,15.175v33.979C121.817,118.479,114.989,125.307,106.643,125.307z"/>
  <path fill="currentColor" d="M106.971,48.201H85.867c-8.346,0-15.174-6.828-15.174-15.174V19.154c0-8.346,6.828-15.174,15.174-15.174
    h21.104c8.346,0,15.174,6.828,15.174,15.174v13.874C122.145,41.373,115.317,48.201,106.971,48.201z"/>
`];

const InfoIcon = ['129.6 129.6', `
<path fill="#898989" d="M99.47,4.19H73.536H56.064H30.131c-7.464,0-13.572,6.107-13.572,13.571v25.904v68.174
    c0,0.467,0.024,0.928,0.07,1.383c0.093,0.909,0.277,1.793,0.542,2.642c0.133,0.424,0.286,0.839,0.458,1.245
    c2.068,4.866,6.903,8.302,12.501,8.302h0h69.338h0.001c5.598,0,10.433-3.436,12.5-8.302c0.689-1.622,1.071-3.403,1.071-5.27V43.665
    V17.761C113.041,10.297,106.934,4.19,99.47,4.19z M101.322,94.959c0,2.333-1.909,4.241-4.241,4.241H32.52
    c-2.333,0-4.241-1.908-4.241-4.241v-6.126c0-2.333,1.908-4.241,4.241-4.241h64.56c2.332,0,4.241,1.908,4.241,4.241V94.959z
     M101.322,67.627c0,2.333-1.909,4.241-4.241,4.241H32.52c-2.333,0-4.241-1.908-4.241-4.241v-6.126c0-2.333,1.908-4.241,4.241-4.241
    H97.08c2.332,0,4.241,1.909,4.241,4.241V67.627z M101.322,40.151c0,2.333-1.909,4.241-4.241,4.241H32.52
    c-2.333,0-4.241-1.908-4.241-4.241v-6.126c0-2.333,1.908-4.241,4.241-4.241H97.08c2.332,0,4.241,1.909,4.241,4.241V40.151z"/>
`];

const StatusIcon = ['129.6 129.6', `
  <g id="Dashboard">
    <g>
        <path fill="#828282" d="M17.809,122.466c-5.504,0-10.008-4.504-10.008-10.008v-9.324c0-5.504,4.504-10.008,10.008-10.008h65.148
            c5.504,0,10.008,4.504,10.008,10.008v9.324c0,5.504-4.503,10.008-10.008,10.008H17.809z"/>
        <path fill="#828282" d="M17.809,79.47c-5.504,0-10.008-4.504-10.008-10.008v-9.325c0-5.504,4.504-10.008,10.008-10.008h93.651
            c5.504,0,10.008,4.503,10.008,10.008v9.325c0,5.504-4.503,10.008-10.008,10.008H17.809z"/>
        <path fill="#828282" d="M17.809,36.142c-5.504,0-10.008-4.503-10.008-10.008v-9.325c0-5.504,4.504-10.008,10.008-10.008H54.46
            c5.504,0,10.008,4.503,10.008,10.008v9.325c0,5.504-4.504,10.008-10.008,10.008H17.809z"/>
    </g>
</g>`];

const AgentsIcon = ['129.6 129.6', `
<g id="Agent">
    <path fill="#898989" d="M100.627,3.8H28.973c-8.346,0-15.174,6.828-15.174,15.174v90.762c0,8.347,6.828,15.175,15.174,15.175
        h71.654c8.346,0,15.174-6.828,15.174-15.175V18.974C115.801,10.628,108.972,3.8,100.627,3.8z M49.013,13.272h31.574v9.698H49.013
        V13.272z M92.925,109.791h-56.25V98.028c-0.008-3.761,1.928-7.217,5.179-9.234l11.612-7.238l-5.045-15.49V50.991
        c0-8.792,7.348-15.944,16.38-15.944S81.18,42.2,81.18,50.991V66.07l-5.525,15.187l12.103,7.543c3.24,2.012,5.176,5.468,5.169,9.24
        L92.925,109.791L92.925,109.791z"/>
</g>`];

const DonatorsIcon = ['129.6 129.6', `
  <g id="Donators">
    <path fill="#898989" d="M112.885,19.729c-12.771-10.884-31.768-8.926-43.491,3.17l-4.592,4.731l-4.592-4.731
      c-11.7-12.097-30.719-14.055-43.492-3.17C2.081,32.222,1.312,54.645,14.41,68.187l45.101,46.568c2.914,3.007,7.646,3.007,10.56,0
      l45.101-46.568C128.292,54.644,127.522,32.222,112.885,19.729L112.885,19.729z"/>
  </g>
`];

const ExportIcon = ['129.6 129.6', `
<g>
	<path fill="#898989" d="M64.761,90.532h-0.023c-0.055-0.002-0.109-0.01-0.166-0.01s-0.109,0.008-0.166,0.01H52.723V47.127
		c0-5.505-4.504-10.008-10.008-10.008h-9.324c-5.504,0-10.008,4.503-10.008,10.008v43.406H11.7c-0.055-0.002-0.111-0.01-0.167-0.01
		s-0.11,0.008-0.166,0.01h-0.021h-0.002c-2.479,0.104-4.461,2.26-4.461,4.906c0,1.411,0.563,2.678,1.464,3.574l-0.003,0.006
		l26.754,25.161l0.021,0.003c0.804,0.698,1.833,1.118,2.956,1.118c1.318,0,2.509-0.584,3.355-1.519l26.332-24.764l-0.002-0.006
		c0.9-0.896,1.463-2.163,1.463-3.574C69.223,92.792,67.24,90.637,64.761,90.532z"/>
	<path fill="#898989" d="M120.513,30.157l0.002-0.006L94.184,5.388c-0.847-0.935-2.038-1.519-3.355-1.519
		c-1.123,0-2.152,0.42-2.957,1.118L87.851,4.99L61.097,30.152l0.003,0.006c-0.901,0.896-1.464,2.163-1.464,3.574
		c0,2.646,1.981,4.802,4.461,4.906h0.002h0.021c0.056,0.002,0.11,0.01,0.166,0.01s0.112-0.008,0.167-0.01h11.682v43.406
		c0,5.504,4.504,10.008,10.008,10.008h9.324c5.504,0,10.008-4.504,10.008-10.008V38.638h11.683c0.057,0.002,0.109,0.01,0.166,0.01
		s0.111-0.008,0.166-0.01h0.023c2.479-0.104,4.462-2.26,4.462-4.906C121.976,32.321,121.413,31.054,120.513,30.157z"/>
</g>
`];

const BillingIcon = ['129.6 129.6', `
<path fill="#898989" d="M115.797,74.964V54.636V14.289c0.001-0.045,0.007-0.089,0.007-0.135s-0.006-0.09-0.007-0.135v-0.367
	c0-0.112-0.013-0.211-0.034-0.303c-0.41-5.113-4.681-9.137-9.9-9.137c-2.611,0-4.979,1.015-6.754,2.661V6.855L85.276,19.346
	L72.409,7.693c-1.823-2.128-4.525-3.481-7.547-3.481c-0.021,0-0.041,0.003-0.062,0.003c-0.021,0-0.041-0.003-0.062-0.003
	c-3.021,0-5.723,1.353-7.546,3.481L44.324,19.345L30.491,6.855v0.019c-1.773-1.646-4.143-2.661-6.754-2.661
	c-5.22,0-9.491,4.025-9.901,9.138c-0.021,0.091-0.033,0.19-0.033,0.301v0.357c-0.001,0.049-0.007,0.096-0.007,0.145
	s0.006,0.096,0.007,0.145v40.337v20.328v40.337c-0.001,0.049-0.007,0.097-0.007,0.146s0.006,0.097,0.007,0.145v0.357
	c0,0.111,0.013,0.21,0.033,0.301c0.41,5.114,4.682,9.139,9.901,9.139c2.611,0,4.98-1.015,6.754-2.661v0.019l13.833-12.491
	l12.867,11.653c1.823,2.127,4.524,3.48,7.546,3.48c0.021,0,0.042-0.003,0.062-0.003c0.021,0,0.042,0.003,0.062,0.003
	c3.021,0,5.724-1.354,7.547-3.48l12.866-11.653l13.833,12.491v-0.019c1.774,1.646,4.143,2.661,6.754,2.661
	c5.22,0,9.49-4.023,9.9-9.137c0.021-0.092,0.034-0.191,0.034-0.303v-0.366c0.001-0.046,0.007-0.09,0.007-0.136
	s-0.006-0.09-0.007-0.136V74.964z M73.124,93.166v8.08h-14.56v-7.84c-7.121-0.8-14.4-2.8-19.44-6.32l6.64-10.96
	c6.08,3.6,12.24,5.12,18.881,5.12c9.2,0,10.8-2.08,10.8-5.2c0-4.08-2.801-4.72-11.601-5.68c-10.56-1.28-21.84-2.96-21.84-17.521
	c0-11.2,5.76-16.48,16.561-18v-6.32h14.56v6.24c7.199,0.8,11.52,2.72,14.801,4.479l-6.721,11.681c-3.359-2-10-3.521-15.28-3.521
	c-7.6,0-8.72,1.921-8.72,4.48c0,4.48,3.92,4.8,12.799,5.92c10.32,1.36,20.48,3.36,20.48,17.04
	C90.484,84.607,85.605,91.326,73.124,93.166z"/>
`];

const ResultsIcon = ['129.6 129.6', `
<path fill="#898989" d="M79.47,111.625c0,5.504-4.504,10.008-10.008,10.008h-9.324c-5.504,0-10.008-4.504-10.008-10.008V46.477
	c0-5.505,4.504-10.008,10.008-10.008h9.324c5.504,0,10.008,4.503,10.008,10.008V111.625z"/>
<path fill="#898989" d="M36.31,111.625c0,5.504-4.504,10.008-10.008,10.008h-9.326c-5.504,0-10.008-4.504-10.008-10.008V74.974
	c0-5.504,4.504-10.008,10.008-10.008h9.326c5.504,0,10.008,4.504,10.008,10.008V111.625z"/>
<path fill="#898989" d="M122.636,111.625c0,5.504-4.504,10.008-10.008,10.008h-9.324c-5.504,0-10.008-4.504-10.008-10.008v-93.65
	c0-5.505,4.504-10.008,10.008-10.008h9.324c5.504,0,10.008,4.503,10.008,10.008V111.625z"/>
`];

const RentabilityIcon = ['129.6 129.6', `
<g>
	<path fill="#828282" d="M30.506,119.841c-3.892,3.891-10.261,3.891-14.152,0l-6.593-6.594c-3.893-3.893-3.892-10.262,0-14.152
		L99.093,9.76c3.893-3.893,10.261-3.893,14.153,0l6.593,6.594c3.893,3.892,3.893,10.26,0,14.152L30.506,119.841z"/>
	<circle fill="#828282" cx="100.8" cy="104.295" r="21"/>
	<circle fill="#828282" cx="27.8" cy="25.295" r="21"/>
</g>`];

const CampagneIcon = ['129.6 129.6', `
<g id="Campaign">
	<path fill="#898989" d="M61.478,87.151L25.67,87.175v28.836c0,1.13,0.516,4.502,3.868,4.502c2.84,0,5.043-2.926,6.286-4.206
		C35.836,116.297,61.478,87.151,61.478,87.151z"/>
	<path fill="#898989" d="M107.401,9.354H22.198c-8.347,0-15.175,6.829-15.175,15.174V75.64c0,8.346,6.828,15.174,15.175,15.174
		h85.202c8.347,0,15.175-6.828,15.175-15.174V24.528C122.575,16.183,115.747,9.354,107.401,9.354z"/>
</g>`];

const TemplatesIcon = ['129.6 129.6', `
<g id="Template_1_">
	<path fill="#898989" d="M107.401,7.854H22.198c-8.347,0-15.175,6.829-15.175,15.174v20.275c0,8.346,6.828,15.174,15.175,15.174
		h85.202c8.347,0,15.175-6.828,15.175-15.174V23.028C122.575,14.683,115.747,7.854,107.401,7.854z"/>
	<path fill="#898989" d="M107.134,71.185H86.031c-8.347,0-15.175,6.828-15.175,15.174v20.274c0,8.346,6.828,15.174,15.174,15.174
		h21.104c8.346,0,15.174-6.828,15.174-15.174V86.358C122.308,78.013,115.479,71.185,107.134,71.185z"/>
	<path fill="#898989" d="M42.967,71.185H21.865c-8.347,0-15.175,6.828-15.175,15.174v20.274c0,8.346,6.828,15.174,15.175,15.174
		h21.103c8.346,0,15.174-6.828,15.174-15.174V86.358C58.141,78.013,51.313,71.185,42.967,71.185z"/>
</g>`];

const UsersIcon = ['129.6 129.6', `
<g id="Users_1_">
	<path fill="#898989" d="M78.675,101.023L56.016,86.725l9.138-14.641c0.766-1.639,1.163-3.45,1.155-5.288V49.055
		c0-9.797-10.001-20.568-21.388-20.568h-0.061c-11.387,0-21.389,10.771-21.389,20.568v17.741c-0.006,1.838,0.39,3.648,1.156,5.288
		l9.138,14.641l-22.659,14.299c-2.704,1.927-4.328,5.21-4.316,8.729l-0.07,12.482h38.121h0.1h38.121l-0.068-12.483
		C83.003,106.233,81.378,102.949,78.675,101.023z"/>
	<path fill="#898989" d="M82.309,49.055v17.717c0.012,4.159-0.908,8.337-2.659,12.085l-0.408,0.878l-0.514,0.821l-0.709,1.135
		l8.098,5.108h4.189h0.084h32.185l-0.06-10.539c0.01-2.971-1.363-5.744-3.645-7.369L99.741,56.819l7.713-12.359
		c0.646-1.382,0.981-2.913,0.975-4.464V25.017c0-8.271-8.443-17.365-18.057-17.365h-0.051c-9.568,0-17.975,9.012-18.05,17.253
		C78.665,31.799,82.309,40.517,82.309,49.055z"/>
</g>`];

const ClientsIcon = ['129.6 129.6', `
<g id="Clients">
	<path fill="#898989" d="M108.745,98.181L79.272,79.582l11.887-19.045c0.994-2.13,1.512-4.487,1.502-6.878V30.582
		c0-12.744-13.012-26.755-27.821-26.755h-0.077c-14.812,0-27.823,14.011-27.823,26.755v23.077c-0.009,2.391,0.507,4.747,1.503,6.878
		l11.888,19.045L20.854,98.181c-3.516,2.506-5.629,6.778-5.612,11.354l-0.093,16.237h49.587h0.132h49.587l-0.094-16.237
		C114.376,104.959,112.263,100.687,108.745,98.181z"/>
</g>
<g id="Clients_1_">
	<path fill="#898989" d="M-199.255,32.181l-29.474-18.599l11.887-19.045c0.994-2.13,1.512-4.487,1.502-6.878v-23.077
		c0-12.744-13.012-26.755-27.821-26.755h-0.077c-14.812,0-27.823,14.011-27.823,26.755v23.077c-0.009,2.391,0.507,4.747,1.503,6.878
		l11.888,19.045l-29.476,18.599c-3.516,2.506-5.629,6.778-5.612,11.354l-0.093,63.765h49.587h0.132h49.587l-0.094-63.765
		C-193.624,38.959-195.737,34.687-199.255,32.181z"/>
</g>
<text transform="matrix(1 0 0 1 27.3 -395.7)" font-family="'MyriadPro-Regular'" font-size="12">|</text>`];

const PrivilegesIcon = ['129.6 129.6', `
<g id="Privileges_1_">
	<path fill="#898989" d="M119.622,58.727L97.395,80.394l5.247,30.596c0.459,2.681-0.643,5.39-2.843,6.986
		c-1.245,0.905-2.719,1.364-4.201,1.364c-1.136,0-2.277-0.271-3.324-0.82l-27.473-14.443L37.325,118.52
		c-2.407,1.267-5.324,1.055-7.524-0.544c-2.2-1.598-3.302-4.307-2.842-6.986l5.247-30.596L9.979,58.727
		C8.03,56.829,7.33,53.99,8.17,51.403c0.84-2.587,3.076-4.472,5.769-4.862l30.718-4.463l13.736-27.834
		c1.204-2.439,3.688-3.983,6.408-3.983c2.719,0,5.202,1.544,6.406,3.983l13.736,27.834l30.718,4.463
		c2.691,0.392,4.928,2.275,5.769,4.862C122.27,53.99,121.569,56.83,119.622,58.727z"/>
</g>`];

const LogsIcon = ['129.6 129.6', `
<g id="Logs">
	<g>
		<path fill="#898989" d="M87.553,4.169v21.498c0,2.393,1.988,3.732,3.723,3.732h21.533L87.553,4.169z"/>
		<path fill="#898989" d="M81.323,43.665c-4.295,0-7.787-3.493-7.787-7.787V4.189H30.13c-7.464,0-13.572,6.107-13.572,13.571v94.078
			c0,7.464,6.107,13.571,13.572,13.571h69.338c7.465,0,13.572-6.107,13.572-13.571V43.665H81.323z M28.279,34.169
			c0-2.333,1.908-4.241,4.241-4.241H54.3c2.333,0,4.241,1.908,4.241,4.241v6.126c0,2.333-1.908,4.241-4.241,4.241H32.52
			c-2.333,0-4.241-1.909-4.241-4.241V34.169z M101.321,94.959c0,2.333-1.908,4.241-4.24,4.241H32.52
			c-2.333,0-4.241-1.908-4.241-4.241v-6.126c0-2.333,1.908-4.241,4.241-4.241H97.08c2.332,0,4.24,1.908,4.24,4.241V94.959z
			 M101.321,67.627c0,2.333-1.908,4.241-4.24,4.241H32.52c-2.333,0-4.241-1.908-4.241-4.241v-6.126c0-2.333,1.908-4.241,4.241-4.241
			H97.08c2.332,0,4.24,1.909,4.24,4.241V67.627z"/>
	</g>
</g>`];

const TimesheetIcon = ['129.6 129.6', `
<text transform="matrix(1 0 0 1 -550.7 -403.7)" font-family="'MyriadPro-Regular'" font-size="12">|</text>
<g>
	<path fill="#828282" d="M98.357,75.77c-13.232,0-23.959,10.728-23.959,23.958c0,13.232,10.727,23.959,23.959,23.959
		s23.959-10.727,23.959-23.959C122.316,86.497,111.589,75.77,98.357,75.77z M112.329,100.45c0,1.361-1.113,2.473-2.473,2.473H97.941
		c-0.012,0-0.021-0.004-0.033-0.004h-0.271c-1.359,0-2.473-1.111-2.473-2.471V84.56c0-1.359,1.113-2.471,2.473-2.471h1.443
		c1.361,0,2.471,1.111,2.471,2.471v11.975h8.307c1.359,0,2.473,1.113,2.473,2.473V100.45z"/>
	<path fill="#828282" d="M98.357,65.721c0.508,0,1.012,0.017,1.514,0.038V25.712c0-4.452-3.643-8.094-8.094-8.094h-9.539v-6.508
		c0-2.858-2.34-5.197-5.197-5.197h-4.846c-2.855,0-5.195,2.339-5.195,5.197v6.508H40.318v-6.508c0-2.858-2.338-5.197-5.197-5.197
		h-4.844c-2.857,0-5.197,2.339-5.197,5.197v6.508h-9.702c-4.451,0-8.093,3.642-8.093,8.094v66.982c0,4.453,3.643,8.094,8.093,8.094
		h48.998c-0.01-0.354-0.026-0.705-0.026-1.061C64.349,80.976,79.605,65.721,98.357,65.721z M37.661,81.929
		c0,3.012-2.464,5.475-5.474,5.475h-8.821c-3.011,0-5.474-2.463-5.474-5.475v-8.821c0-3.011,2.463-5.473,5.474-5.473h8.821
		c3.01,0,5.474,2.462,5.474,5.473V81.929z M37.661,56.017c0,3.011-2.464,5.475-5.474,5.475h-8.821c-3.011,0-5.474-2.464-5.474-5.475
		v-8.82c0-3.011,2.463-5.474,5.474-5.474h8.821c3.01,0,5.474,2.463,5.474,5.474V56.017z M63.543,81.929
		c0,3.012-2.462,5.475-5.474,5.475h-8.82c-3.011,0-5.475-2.463-5.475-5.475v-8.821c0-3.011,2.464-5.473,5.475-5.473h8.82
		c3.012,0,5.474,2.462,5.474,5.473V81.929z M63.543,56.017c0,3.011-2.462,5.475-5.474,5.475h-8.82c-3.011,0-5.475-2.464-5.475-5.475
		v-8.82c0-3.011,2.464-5.474,5.475-5.474h8.82c3.012,0,5.474,2.463,5.474,5.474V56.017z M69.657,56.017v-8.82
		c0-3.011,2.465-5.474,5.477-5.474h8.818c3.012,0,5.475,2.463,5.475,5.474v8.82c0,3.011-2.463,5.475-5.475,5.475h-8.818
		C72.122,61.491,69.657,59.028,69.657,56.017z"/>
</g>`];

const AgentTimeIcon = ['129.6 129.6', `
<path fill="#828282" d="M8.175,64.797c0,31.277,25.349,56.628,56.627,56.628c31.273,0,56.623-25.352,56.623-56.628
	c0-31.269-25.35-56.621-56.623-56.621C33.524,8.176,8.175,33.528,8.175,64.797z M31.779,63.094c0-3.213,2.629-5.843,5.843-5.843
	h19.631v-28.3c0-3.213,2.625-5.843,5.839-5.843h3.414c3.211,0,5.844,2.63,5.844,5.843v37.548c0,3.214-2.633,5.842-5.844,5.842
	h-0.645c-0.026,0-0.05,0.009-0.077,0.009H37.622c-3.214,0-5.843-2.629-5.843-5.844V63.094z"/>`];

const NotificationsIcon = ['129.6 129.6', `
<g>
	<path fill="#898989" d="M63.467,72.406c9.9,0,18-8.101,18-18V22.072c0-9.899-8.1-18-18-18H25.132c-9.9,0-18,8.101-18,18v32.334
		c0,9.899,8.1,18,18,18h3.178v15.037c0,0.857,0.391,3.418,2.937,3.418c2.156,0,3.829-2.222,4.773-3.193
		c0.005-0.005,7.712-8.766,13.428-15.262H63.467z"/>
	<path fill="#898989" d="M104.468,38.582h-6.002v15.823c0,19.299-15.701,35-35,35H55.16c0.265,9.674,8.241,17.509,17.976,17.509
		h5.744c4.748,5.396,13.959,15.867,13.965,15.872c0.811,0.834,2.248,2.742,4.1,2.742c2.186,0,2.521-2.199,2.521-2.936v-15.679h5.002
		c9.9,0,18-8.101,18-18V56.582C122.468,46.682,114.368,38.582,104.468,38.582z"/>
</g>`];

const SupportIcon = ['129.6 129.6', `
<g id="Setting">
	<path fill="#898989" d="M120.543,81.638l-8.066-6.64c1.431-6.725,1.431-13.673,0-20.396l8.066-6.64
		c1.922-1.575,2.417-4.312,1.169-6.459l-8.28-14.341c-1.236-2.155-3.854-3.095-6.179-2.217l-9.79,3.669
		c-5.103-4.608-11.117-8.086-17.657-10.205L78.088,8.107c-0.402-2.452-2.523-4.25-5.009-4.242H56.52
		c-2.484-0.008-4.606,1.79-5.009,4.242l-1.717,10.302c-6.54,2.118-12.557,5.597-17.656,10.204l-9.792-3.669
		c-2.325-0.877-4.942,0.062-6.179,2.218l-8.28,14.342c-1.248,2.147-0.751,4.884,1.171,6.459l8.065,6.639
		c-1.431,6.725-1.431,13.673,0,20.396l-8.066,6.64c-1.922,1.575-2.417,4.312-1.17,6.46l8.28,14.34
		c1.235,2.156,3.854,3.096,6.179,2.217l9.791-3.668c5.1,4.608,11.117,8.086,17.656,10.205l1.717,10.303
		c0.402,2.45,2.524,4.249,5.009,4.241h16.561c2.484,0.008,4.605-1.791,5.009-4.241l1.718-10.303
		c6.539-2.119,12.556-5.597,17.656-10.205l9.791,3.669c2.324,0.878,4.94-0.062,6.179-2.217l8.279-14.342
		C122.958,85.949,122.464,83.213,120.543,81.638z M64.8,88.047c-12.84,0-23.248-10.408-23.248-23.247S51.96,41.553,64.8,41.553
		C77.633,41.567,88.032,51.967,88.047,64.8C88.047,77.639,77.639,88.047,64.8,88.047z"/>
</g>`];

export const icons = Object.assign({}, {
  sygnet,
  logo,
  logoNegative
}, {
  cilAlignCenter,
  cilAlignLeft,
  cilAlignRight,
  cilApplicationsSettings,
  cilArrowRight,
  cilArrowBottom,
  cilArrowTop,
  cilAsterisk,
  cilBan,
  cilBasket,
  cilBell,
  cilBold,
  cilBookmark,
  cilCalculator,
  cilCalendar,
  cilCloudDownload,
  cilChartPie,
  cilCheck,
  cilChevronBottom,
  cilChevronLeft,
  cilChevronRight,
  cilChevronTop,
  cilCircle,
  cilCheckCircle,
  cilCode,
  cilCommentSquare,
  cilCreditCard,
  cilCursor,
  cilCursorMove,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeLetter,
  cilEnvelopeOpen,
  cilEuro,
  cilGlobeAlt,
  cilGrid,
  cilFile,
  cilFullscreen,
  cilFullscreenExit,
  cilGraph,
  cilHeart,
  cilHome,
  cilInbox,
  cilIndentDecrease,
  cilIndentIncrease,
  cilInputPower,
  cilItalic,
  cilJustifyCenter,
  cilJustifyLeft,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilListNumbered,
  cilListRich,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMap,
  cilMoon,
  cilNotes,
  cilOptions,
  cilPaperclip,
  cilPaperPlane,
  cilPencil,
  cilPeople,
  cilPhone,
  cilPrint,
  cilPuzzle,
  cilSave,
  cilScrubber,
  cilSettings,
  cilShare,
  cilShareAll,
  cilShareBoxed,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilSun,
  cilTags,
  cilTask,
  cilTrash,
  cilUnderline,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilUserUnfollow,
  cilX,
  cilXCircle,
  cilWarning,
  cilMoney,
  cilPlus,
  cilClone,
  cilAccountLogout,
  cilMinus,
  cilDataTransferDown,
  cilDataTransferUp,
  cilLoop,
  cilPlaylistAdd,
  cilFlagAlt,
  cilInfo,
  cilExternalLink,
  cilCheckAlt,
  cilActionUndo,
  cilArrowCircleTop,
  cilCommentBubble,
  cilDelete,
  cilClock,
  cilCaretBottom
}, {
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl
}, {
  cibSkype,
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibStackoverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
  cibCcAmex,
  cibOpsgenie,
  cibGmail
}, {
  DashIcon,
  InfoIcon,
  StatusIcon,
  AgentsIcon,
  DonatorsIcon,
  ExportIcon,
  BillingIcon,
  ResultsIcon,
  RentabilityIcon,
  CampagneIcon,
  TemplatesIcon,
  UsersIcon,
  ClientsIcon,
  PrivilegesIcon,
  LogsIcon,
  TimesheetIcon,
  AgentTimeIcon,
  NotificationsIcon,
  SupportIcon
});
